import React, { useState, useEffect, useMemo } from 'react';
import Table from '../partials/Table';
import axios from 'axios'
import styled from 'styled-components';

function RingbaPubTable({ loadingData, setLoadingData }) {

    const [data, setData] = useState();

    useEffect(() => {
        if (loadingData) {
            // if the result is not ready so you make the axios call
            getPublishers();
        }
    }, [loadingData]);

    const getPublishers = () => {
        axios.get('https://emaildrop.com/ringba/getPublishers', {}, {})
            .then(response => {
                setData(response.data);
                setLoadingData(false);
            }
            )
            .catch(error => console.log('api errors:', error));
    }

    const handleSaveEditedValue = (rowIndex, columnId, editedValue, rowId) => {
        const updatedData = [...data];
        updatedData[rowIndex][columnId] = editedValue;
        setData(updatedData);


        const payload = {
            row: rowId,
            column: columnId,
            value: editedValue
        }

        axios.post('https://emaildrop.com/ringba/updatePublisher', payload, {})
            .then(response => {
            })
            .catch(error => console.log('api errors:', error));

        //send paylaod to backend
        // Implement the logic to update the data with the edited value
        // You may use the rowIndex and columnId to identify which cell was edited
        // Update the data source (e.g., an array or API) with the new value
    }

    const columns = useMemo(
        () => [
            {
                Header: 'Affiliate ID',
                accessor: 'affiliate_id',
                className: 'editable',
                isEditable: true

            },
            
            {
                Header: 'Campaign ID',
                accessor: 'campaign_id',
                className: 'editable',
                isEditable: true
            },
            {
                Header: 'Creative ID',
                accessor: 'creative_id',
                className: 'editable',
                isEditable: true

            },
            {
                Header: 'Sub Affiliate',
                accessor: 'sub_affiliate',
                className: 'editable',
                isEditable: true

            },
            {
                Header: 'Target',
                accessor: 'target',
                className: 'editable',
                isEditable: true

            },
            {
                Header: 'Payout',
                accessor: 'payout',
                className: 'editable',
                isEditable: true

            },
            {
                Header: 'Affiliate Payout',
                accessor: 'affiliate_payout',
                className: 'editable',
                isEditable: true

            }
        ], []
    );

    return (

        <>
            {loadingData ? (
                <p>Loading Please wait...</p>
            ) : (
                <Styles>
                    <Table className="ringbaPubTable" columns={columns} data={data}  onEditSave={handleSaveEditedValue} />
                </Styles>
            )}
        </>

    );
}

const Styles = styled.div`
  padding: 1rem 0;

  .editable-cell {
    width: 100%; /* Takes up 100% of its parent's width */
    height: 30px; /* You can adjust the height as needed */
    text-align: center; /* Center the text */
    line-height: 50px; /* Vertically center the text */
    cursor: pointer; 
  }

  table {
    border-collapse: separate;
    border: 1px solid #66BFBF;
    width: 100%;

    tr {
      :last-child {
        td {
          border-bottom: 0;
        }
      }
    }

    th,
    td {
      margin: 0;
      padding: 0.5rem;
      border-bottom: 1px solid #66BFBF;
      border-right: 1px solid #66BFBF;
      :last-child {
        border-right: 0;
      }
    }
   
  }
`;


export default RingbaPubTable;